// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "./controllers"
import "./channels"
import "./utils/font_loader"
import "./lib/confirmation"
import { loadVendor } from "./lib/load_vendor"

// Auto-handles any <input type="file" data-direct-upload-url="..."> — emitted
// by Rails when you pass direct_upload: true to a file_field. The file uploads
// to ActiveStorage before the form submits and the resulting signed_id is sent
// as the field's value, so it survives form validation failures (whereas a
// plain file input can't be repopulated by the browser).
ActiveStorage.start()

// NOTE: hls.js (~505KB) and livekit-client (~475KB) are NOT bundled here. Their
// Stimulus controllers (video-player / live-room) stay in the normal manifest,
// but they lazy-load the heavy library on demand via lib/load_vendor.js the
// first time a video/live element connects — keeping ~1MB out of this universal
// bundle. URLs come from <meta name="js-hls">/<meta name="js-livekit">
// (shared/_lazy_js_meta), rendered in the layouts that host those pages.

// ⛔ Chartkick et Chart.js étaient déclarés dans package.json et importés par
// personne : les 13 vues qui posent un graphique restaient sur « Chargement… »
// sans une erreur en console (le script du gem attend un événement
// `chartkick:load` au lieu d'échouer). Mesuré le 12/09/2026 sur
// /admin/analytics : window.Chartkick et window.Chart tous deux `undefined`.
//
// La bibliothèque reste hors du bundle universel (même patron que hls /
// livekit) : on la réclame seulement si la page porte vraiment un graphique. Le
// marqueur est le script que le gem écrit lui-même, pas un nom de classe — un
// `id` de bloc peut être redéfini par la vue, `new Chartkick[` non.
const pageAUnGraphique = () =>
    Array.from(document.scripts).some((s) => s.textContent.includes("new Chartkick["))

const chargerChartkickSiBesoin = () => {
    if (window.Chartkick || !pageAUnGraphique()) return
    loadVendor("chartkick").catch((e) => console.warn("[chartkick]", e.message))
}

document.addEventListener("turbo:load", chargerChartkickSiBesoin)
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", chargerChartkickSiBesoin)
} else {
    chargerChartkickSiBesoin()
}
